export default {
  timeTab: {
    today: '1 NGÀY',
    oneWeek: '5 NGÀY',
    oneMonth: '20 NGÀY',
    yearToDate: 'TÍNH ĐẾN HIỆN TẠI',
  },
  footerText:
    'Gía: x 1,000. Khối lượng: x 1,000. Giá trị: x 1,000,000. Dữ liệu cập nhật cuối ngày (Trước 16:00 GMT+7)',
  treeMapSellTitle: 'Bán %{tradeValue} Tỷ',
  treeMapBuyTitle: 'Mua  %{tradeValue} Tỷ',
  treeMapNetSellTitle: 'Bán ròng %{tradeValue} Tỷ',
  treeMapNetBuyTitle: 'Mua ròng  %{tradeValue} Tỷ',
  tooltipBuyTitle: 'GT Tự doanh Mua ',
  tooltipBuyVolumeTitle: 'KL Tự doanh Mua: ',
  tooltipBuyNetTitle: 'GT Tự doanh Mua Ròng: ',
  tooltipSellTitle: 'GT Tự doanh Bán: ',
  tooltipSellVolumeTitle: 'KL Tự doanh Bán: ',
  tooltipSellNetTitle: 'GT Tự doanh Bán Ròng: ',
  updatedDate: 'Ngày cập nhật: %{date}',
  PROPRIETARY_VALUE: 'GT Tự Doanh',
  PROPRIETARY_NET: 'GT Tự Doanh Ròng',

  treeMapTickerBuyTitle: 'Mua %{tradeValue} Tr.',
  treeMapTickerSellTitle: 'Bán %{tradeValue} Tr.',

  treeMapMilNetBuyTitle: 'Mua ròng %{tradeValue} Tr.',
  treeMapMilNetSellTitle: 'Bán ròng %{tradeValue} Tr.',
};
